// libs
import React, { memo } from 'react';

//styles
import { Container, ButtonWrapper, Button } from './styles';

//constants
import { CANCEL, RESET, APPLY } from './constants';

// defs
interface IButtonsContainer {
  onApplyClick: (value: string) => void;
  collapseFilter: () => void;
  selectedOptions: string[];
  setSelectedOptions: (item: string[]) => void;
  isApplyButtonDisabled: boolean;
}

function ButtonsContainer({
  onApplyClick,
  collapseFilter,
  selectedOptions,
  setSelectedOptions,
  isApplyButtonDisabled,
}: IButtonsContainer) {
  const onApply = (options: string[]) => {
    collapseFilter();
    onApplyClick(options.join('_'));
  };

  return (
    <Container>
      <Button kind="secondary" shape="default" size="small" onClick={collapseFilter}>
        {CANCEL}
      </Button>
      <ButtonWrapper>
        <Button
          kind="secondary"
          shape="default"
          size="small"
          disabled={selectedOptions.length === 0}
          onClick={() => setSelectedOptions([])}
          isApplyButton={false}
        >
          {RESET}
        </Button>
        <Button
          kind="primary"
          shape="default"
          size="small"
          disabled={isApplyButtonDisabled}
          onClick={() => onApply(selectedOptions)}
          isApplyButton
        >
          {APPLY}
        </Button>
      </ButtonWrapper>
    </Container>
  );
}

export default memo(ButtonsContainer);
